/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DisableCardGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type DisableCardRequest = {
  accountID: string;
  cardID: string;
};

export type DisableCardResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export const DisableCardGlobals$inboundSchema: z.ZodType<
  DisableCardGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type DisableCardGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const DisableCardGlobals$outboundSchema: z.ZodType<
  DisableCardGlobals$Outbound,
  z.ZodTypeDef,
  DisableCardGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function disableCardGlobalsToJSON(
  disableCardGlobals: DisableCardGlobals,
): string {
  return JSON.stringify(
    DisableCardGlobals$outboundSchema.parse(disableCardGlobals),
  );
}
export function disableCardGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<DisableCardGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableCardGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableCardGlobals' from JSON`,
  );
}

/** @internal */
export const DisableCardRequest$inboundSchema: z.ZodType<
  DisableCardRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  cardID: z.string(),
});
/** @internal */
export type DisableCardRequest$Outbound = {
  accountID: string;
  cardID: string;
};

/** @internal */
export const DisableCardRequest$outboundSchema: z.ZodType<
  DisableCardRequest$Outbound,
  z.ZodTypeDef,
  DisableCardRequest
> = z.object({
  accountID: z.string(),
  cardID: z.string(),
});

export function disableCardRequestToJSON(
  disableCardRequest: DisableCardRequest,
): string {
  return JSON.stringify(
    DisableCardRequest$outboundSchema.parse(disableCardRequest),
  );
}
export function disableCardRequestFromJSON(
  jsonString: string,
): SafeParseResult<DisableCardRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableCardRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableCardRequest' from JSON`,
  );
}

/** @internal */
export const DisableCardResponse$inboundSchema: z.ZodType<
  DisableCardResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
  });
});
/** @internal */
export type DisableCardResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
};

/** @internal */
export const DisableCardResponse$outboundSchema: z.ZodType<
  DisableCardResponse$Outbound,
  z.ZodTypeDef,
  DisableCardResponse
> = z.object({
  headers: z.record(z.array(z.string())),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
  });
});

export function disableCardResponseToJSON(
  disableCardResponse: DisableCardResponse,
): string {
  return JSON.stringify(
    DisableCardResponse$outboundSchema.parse(disableCardResponse),
  );
}
export function disableCardResponseFromJSON(
  jsonString: string,
): SafeParseResult<DisableCardResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableCardResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableCardResponse' from JSON`,
  );
}
